import { render, staticRenderFns } from "./body-refuse.vue?vue&type=template&id=2362e1ba"
import script from "./body-refuse.vue?vue&type=script&lang=js"
export * from "./body-refuse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports